export default function deleteReviewPageType() {
  localStorage.removeItem("review_page_type");
}
